(() => {
  const DB = window.BOOSTLABS_VEHICLES || {};
  const STORAGE = 'boostlabs_vehicle_v1';
  const normalize = (s='') => s.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
  const textNorm = (s='') => normalize(s).replace(/-/g,' ');
  const getSaved = () => { try { return JSON.parse(localStorage.getItem(STORAGE) || 'null'); } catch(e){ return null; } };
  const save = (v) => { localStorage.setItem(STORAGE, JSON.stringify(v)); window.dispatchEvent(new CustomEvent('boostlabs:vehicle',{detail:v})); };
  const clear = () => { localStorage.removeItem(STORAGE); window.dispatchEvent(new CustomEvent('boostlabs:vehicle',{detail:null})); };
  const makeLabel = (v) => v?.custom ? v.customMake : (DB[v?.make]?.label || v?.make || '');
  const modelObj = (v) => DB[v?.make]?.models?.find(m => m.id === v?.model);
  const modelLabel = (v) => v?.custom ? v.customModel : (modelObj(v)?.label || v?.model || '');
  const vehicleLabel = (v) => !v ? '' : [makeLabel(v), modelLabel(v), v.year, (v.engine && !/todas|any|no lo se/i.test(v.engine)) ? v.engine : ''].filter(Boolean).join(' · ');

  function populateMake(select, selected='') {
    if (!select) return;
    const first = select.options[0]?.outerHTML || '<option value="">Selecciona marca</option>';
    select.innerHTML = first + Object.entries(DB).map(([id,m]) => `<option value="${id}" ${id===selected?'selected':''}>${m.label}</option>`).join('');
  }
  function populateModel(select, make, selected='') {
    if (!select) return;
    const placeholder = select.options[0]?.textContent || 'Selecciona modelo';
    const models = DB[make]?.models || [];
    select.innerHTML = `<option value="">${placeholder}</option>` + models.map(m => `<option value="${m.id}" ${m.id===selected?'selected':''}>${m.label}</option>`).join('');
    select.disabled = !make || make === 'other' || !models.length;
  }
  function populateYear(select, make, model, selected='') {
    if (!select) return;
    const placeholder = select.options[0]?.textContent || 'Selecciona año';
    const m = DB[make]?.models?.find(x => x.id === model);
    select.innerHTML = `<option value="">${placeholder}</option>`;
    if (!m) { select.disabled = true; return; }
    const current = new Date().getFullYear()+1;
    const end = Math.min(m.end || current, current);
    for (let y=end; y>=m.start; y--) select.insertAdjacentHTML('beforeend', `<option value="${y}" ${String(y)===String(selected)?'selected':''}>${y}</option>`);
    select.disabled = false;
  }
  function populateEngine(select, make, model, selected='') {
    if (!select) return;
    const placeholder = select.options[0]?.textContent || 'Cualquiera / No lo sé';
    const m = DB[make]?.models?.find(x => x.id === model);
    const engines = m?.engines || [];
    select.innerHTML = `<option value="">${placeholder}</option>` + engines.filter(x=>!/^todas|^any/i.test(x)).map(e => `<option value="${normalize(e)}" data-label="${e}" ${normalize(e)===selected?'selected':''}>${e}</option>`).join('');
    select.disabled = !m;
  }

  function initSelector(root) {
    const make = root.querySelector('[data-vehicle-make]');
    const model = root.querySelector('[data-vehicle-model]');
    const year = root.querySelector('[data-vehicle-year]');
    const engine = root.querySelector('[data-vehicle-engine]');
    const custom = root.querySelector('[data-vehicle-custom]');
    const customMake = root.querySelector('[data-vehicle-custom-make]');
    const customModel = root.querySelector('[data-vehicle-custom-model]');
    const submit = root.querySelector('[data-vehicle-submit]');
    const clearBtn = root.querySelector('[data-vehicle-clear]');
    const saved = getSaved();
    populateMake(make, saved?.make || '');
    if (saved?.custom) {
      make.value = 'other'; custom.hidden = false; customMake.value = saved.customMake || ''; customModel.value = saved.customModel || '';
    } else if (saved?.make) {
      populateModel(model, saved.make, saved.model); populateYear(year, saved.make, saved.model, saved.year); populateEngine(engine, saved.make, saved.model, saved.engine);
    }
    if (saved) clearBtn.hidden = false;

    make?.addEventListener('change', () => {
      const isOther = make.value === 'other'; custom.hidden = !isOther;
      populateModel(model, make.value); populateYear(year,'',''); populateEngine(engine,'','');
    });
    model?.addEventListener('change', () => { populateYear(year, make.value, model.value); populateEngine(engine, make.value, model.value); });
    submit?.addEventListener('click', () => {
      let v;
      if (make.value === 'other') {
        if (!customMake.value.trim() || !customModel.value.trim()) { customMake.focus(); return; }
        v = {custom:true, make:'other', customMake:customMake.value.trim(), customModel:customModel.value.trim(), year:'', engine:''};
      } else {
        if (!make.value || !model.value || !year.value) { (!make.value?make:(!model.value?model:year)).focus(); return; }
        const engOpt = engine.selectedOptions?.[0];
        v = {make:make.value, model:model.value, year:year.value, engine:engine.value || '', engineLabel:engOpt?.dataset?.label || engOpt?.textContent || ''};
      }
      save(v); updateVehicleUI(v); closeModal();
      const url = new URL('/collections/all', window.location.origin); url.searchParams.set('fit','1');
      if (v.make) url.searchParams.set('make',v.make); if (v.model) url.searchParams.set('model',v.model); if (v.year) url.searchParams.set('year',v.year); if (v.engine) url.searchParams.set('engine',v.engine);
      window.location.href = url.toString();
    });
    clearBtn?.addEventListener('click', () => { clear(); updateVehicleUI(null); window.location.reload(); });
  }

  function sourceTokens(el) {
    return textNorm([el.dataset.productTitle||'', el.dataset.productTags||'', el.dataset.productDescription||''].join(' '));
  }
  function yearRanges(source) {
    const raw=(source||'').replace(/\s+/g,' '); const ranges=[];
    const re=/(19\d{2}|20\d{2})\s*(?:-|–|—|to|a)\s*(19\d{2}|20\d{2})/g; let m;
    while((m=re.exec(raw))) ranges.push([+m[1],+m[2]]);
    return ranges;
  }
  function hasToken(source, term='') { const n=textNorm(term); return !!n && (` ${source} `).includes(` ${n} `); }
  function hasAny(source, aliases=[]) { return aliases.some(a => hasToken(source,a)); }
  function compatibility(el, v) {
    if (!v) return 'none';
    const src = sourceTokens(el);
    const raw = [el.dataset.productTitle||'', el.dataset.productTags||'', el.dataset.productDescription||''].join(' ').toLowerCase();
    if (!src) return 'unknown';
    if (/\buniversal\b|fit universal|fit-universal/.test(src)) return 'compatible';
    const make = v.custom ? textNorm(v.customMake) : textNorm(DB[v.make]?.label || v.make);
    const m = modelObj(v);
    const aliases = v.custom ? [v.customModel] : (m?.aliases || [v.model]);
    const makePresent = hasToken(src,make);
    const modelPresent = hasAny(src, aliases);
    const knownMakes = Object.values(DB).filter(x=>x.label && x.label!=='Otra / No aparece').map(x=>textNorm(x.label));
    const ambiguousMakes = new Set(['seat','mini','ram','smart','genesis']);
    const anotherMake = knownMakes.some(x => x !== make && x.length>2 && !ambiguousMakes.has(x) && hasToken(src,x));
    const hasFitSignal = /(fit-|compatible|compatib|bmw|audi|volkswagen|seat|honda|chevrolet|infiniti|toyota|nissan|mercedes|ford|opel|peugeot|renault|skoda|subaru|mazda|citroen|cupra)/.test(src);
    if (anotherMake && !makePresent) return 'incompatible';
    if (makePresent && modelPresent) {
      const ranges = yearRanges(raw); if (ranges.length && v.year) { const y=+v.year; if (!ranges.some(([a,b])=>y>=Math.min(a,b)&&y<=Math.max(a,b))) return 'incompatible'; }
      if (v.engine) { const eng = textNorm(v.engineLabel || v.engine); if (eng && /s55|b58|n55|k20|tdi|tsi|tfsi|v6|v8|3 0t|2 0t|lt1|lt4|lt5|vq37|vr30/.test(src) && !src.includes(eng)) return 'unknown'; }
      return 'compatible';
    }
    if (makePresent && !modelPresent) return hasFitSignal ? 'incompatible' : 'unknown';
    return hasFitSignal ? 'unknown' : 'unknown';
  }

  function updateVehicleUI(v=getSaved()) {
    document.querySelectorAll('[data-current-vehicle]').forEach(el => { el.textContent = v ? vehicleLabel(v) : (el.dataset.emptyLabel || 'Mi coche'); el.classList.toggle('has-vehicle', !!v); });
    document.querySelectorAll('[data-vehicle-clear]').forEach(el => el.hidden = !v);
    document.querySelectorAll('[data-fitment-product]').forEach(el => updateProductFitment(el,v));
    applyCollectionFilter(v);
  }
  function updateProductFitment(el,v) {
    const status = compatibility(el,v); el.dataset.fitmentStatus=status;
    const msg=el.querySelector('[data-fitment-message]'); const sub=el.querySelector('[data-fitment-sub]');
    if (!msg) return;
    const lang=el.dataset.lang||'es';
    if (!v) { msg.textContent=lang==='en'?'Select your car to check fitment':'Selecciona tu coche para comprobar compatibilidad'; if(sub) sub.textContent=''; return; }
    const label=vehicleLabel(v);
    if (status==='compatible') { msg.textContent=lang==='en'?'✓ Compatible with your car':'✓ Compatible con tu coche'; if(sub) sub.textContent=label; }
    else if (status==='incompatible') { msg.textContent=lang==='en'?'✕ This fitment does not match your car':'✕ Esta compatibilidad no coincide con tu coche'; if(sub) sub.textContent=label; }
    else { msg.textContent=lang==='en'?'Compatibility not confirmed':'Compatibilidad no confirmada'; if(sub) sub.textContent=(lang==='en'?'Check the product fitment before ordering · ':'Comprueba la ficha antes de comprar · ')+label; }
  }
  function applyCollectionFilter(v=getSaved()) {
    const params=new URLSearchParams(location.search); const active=params.get('fit')==='1';
    const cards=[...document.querySelectorAll('[data-fitment-card]')]; if(!cards.length) return;
    let visible=0, exact=0;
    cards.forEach(card=>{
      const s=compatibility(card,v); card.dataset.fitmentStatus=s;
      const hide=active && v && s==='incompatible'; card.hidden=hide; if(!hide) visible++; if(s==='compatible') exact++;
      const badge=card.querySelector('[data-card-fitment-badge]'); if(badge){ badge.hidden=!v; badge.textContent=s==='compatible'?'✓':(s==='incompatible'?'✕':'?'); badge.title=s; }
    });
    const summary=document.querySelector('[data-fitment-filter-summary]');
    if(summary){
      if(active&&v) summary.textContent=(document.documentElement.lang||'').startsWith('en') ? `${visible} products shown · ${exact} direct matches for ${vehicleLabel(v)}` : `${visible} productos mostrados · ${exact} con coincidencia directa para ${vehicleLabel(v)}`;
      else summary.textContent='';
    }
  }

  const modal=()=>document.querySelector('[data-vehicle-modal]');
  function openModal(){ const m=modal(); if(!m)return; m.hidden=false; document.documentElement.classList.add('vehicle-modal-open'); setTimeout(()=>m.querySelector('select,input,button')?.focus(),20); }
  function closeModal(){ const m=modal(); if(!m)return; m.hidden=true; document.documentElement.classList.remove('vehicle-modal-open'); }

  document.addEventListener('DOMContentLoaded',()=>{
    document.querySelectorAll('[data-vehicle-selector]').forEach(initSelector);
    document.querySelectorAll('[data-vehicle-open]').forEach(b=>b.addEventListener('click',openModal));
    document.querySelectorAll('[data-vehicle-close]').forEach(b=>b.addEventListener('click',closeModal));
    document.addEventListener('keydown',e=>{if(e.key==='Escape')closeModal();});
    updateVehicleUI(getSaved());
  });
  window.addEventListener('boostlabs:vehicle',e=>updateVehicleUI(e.detail));
  window.BoostLabsFitment={getSaved,save,clear,compatibility,vehicleLabel};
})();